import { render, staticRenderFns } from "./editWebsiteMenu.vue?vue&type=template&id=379d1407"
import script from "./editWebsiteMenu.vue?vue&type=script&lang=js"
export * from "./editWebsiteMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports